import { useEffect, useMemo, useState } from 'react';
import Hidden from '@mui/material/Hidden';
import { Box, Tab, Tabs } from '@mui/material';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useIsWidthDown } from 'hooks/mediaQuery';
import { isLayoutEditorEnabled } from 'pages/PosSettings/FloorPlan/floorPlanStorage';

export const routes = [
  { id: 'TABLE_POS_TABLES', plan: '', path: '/tables', name: 'Tables' },
  { id: 'TABLE_POS_SECTIONS', plan: '', path: '/sections', name: 'Sections' },
  {
    id: 'TABLE_POS_FLOOR_PLAN',
    plan: '',
    path: '/floor-plan',
    name: 'Floor Plan',
  },
];

const PosTabs = () => {
  const history = useHistory();
  const mdDown = useIsWidthDown('md');
  const { currentBusiness } = useSelector(({ business }) => business);
  const layoutEditorEnabled = isLayoutEditorEnabled(currentBusiness);
  const visibleRoutes = useMemo(
    () =>
      routes.filter(
        (route) => route.id !== 'TABLE_POS_FLOOR_PLAN' || layoutEditorEnabled
      ),
    [layoutEditorEnabled]
  );
  const [value, setValue] = useState(history.location.pathname);

  useEffect(() => {
    const isVisible = visibleRoutes.some(
      (route) => `/table-setup${route.path}` === history.location.pathname
    );
    if (!isVisible) {
      history.replace(`/table-setup${visibleRoutes[0].path}`);
      setValue(`/table-setup${visibleRoutes[0].path}`);
      return;
    }
    setValue(history.location.pathname);
  }, [history, history.location.pathname, visibleRoutes]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    history.push(newValue);
  };

  return (
    <Hidden mdDown={mdDown}>
      <Box sx={{ width: '800px' }}>
        <Box sx={{ width: '100%' }}>
          <Tabs
            TabIndicatorProps={{
              style: {
                backgroundColor: '#2D7FF9',
              },
            }}
            variant="scrollable"
            scrollButtons="auto"
            selectionFollowsFocus
            value={value}
            onChange={handleChange}
          >
            {visibleRoutes.map(({ id, path, name }) => (
              <Tab
                sx={{
                  '&.Mui-selected': { color: '#2D7FF9' },
                }}
                key={id || path}
                value={`/table-setup${path}`}
                label={name}
              />
            ))}
          </Tabs>
        </Box>
      </Box>
    </Hidden>
  );
};
export default PosTabs;
